import {DataBaseComponent, DataBaseComponentState} from "../../components/DataBaseComponent";
import SaveDialogLayout from "../../components/DialogLayout/SaveDialogLayout";
import {Text} from "../../components/form";
import repository from "../../client/repository";
import * as React from "react";
import { Callout } from "@octopusdeploy/design-system-components";

interface Props {
    onChange: (taskId?: string) => void;
}

interface State extends DataBaseComponentState {
    portalInstanceName: string;
}

class DeleteE2eTestResourcesDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            portalInstanceName: ""
        };
    }

    render() {
        return <SaveDialogLayout
            title="Delete E2E Test Resources" saveButtonLabel="Delete"
            onSaveClick={() => this.deleteE2eResources()}
            errors={this.state.errors}
            saveButtonDisabled={!this.state.portalInstanceName}
            busy={this.state.busy}>
            <Callout type="warning" title="!!! Do not use in Production !!!">
                This process can only be used in the preprod environment.
            </Callout>

            <p>This process deletes all E2E-test-created resource groups with the specified portal instance name.</p>

            <p>The portal instance name must match the <code>PortalInstanceName</code> tag applied to Azure resource groups.</p>

            <p>This usually matches the name of the primary reef. E.g. <code>hmaintd01</code> or <code>hoctosrvretd01</code></p>

            {this.state.portalInstanceName.length > 0 && this.state.portalInstanceName[0] !== "h" && (
                <Callout type="danger" title="Are you sure?">
                    The portal instance name for E2Es usually starts with 'h'
                </Callout>
            )}

            <Text label="Portal instance name"
                value={this.state.portalInstanceName}
                onChange={value => this.setState({portalInstanceName: value})}
            />
        </SaveDialogLayout>;
    }

    private async deleteE2eResources(): Promise<boolean> {
        return this.doBusyTask(async () => {
            const taskId = await repository.AzureRegions.deleteE2eResources(this.state.portalInstanceName);
            this.props.onChange(taskId);
        });
    }
}

export default DeleteE2eTestResourcesDialog;
